export const CARTEVITALE_LESSONS = [
  {
    id: 'cartevitale-1',
    numero: 1,
    titre: "Comprendre votre carte Vitale",
    sousTitre: "À quoi ça sert vraiment ?",
    contexte: "Vous avez une carte Vitale dans votre portefeuille mais vous ne savez pas exactement à quoi elle sert ni comment l'utiliser correctement.",
    explication: [
      "**La carte Vitale** est votre carte d'assurance maladie. Elle prouve que vous êtes bien affilié à la Sécurité sociale et permet le remboursement de vos soins.",
      "**Elle contient** votre numéro de sécurité sociale (15 chiffres), votre nom, et éventuellement les informations de vos ayants droit (enfants).",
      "**Comment l'utiliser** : présentez-la à chaque consultation chez le médecin, à la pharmacie, à l'hôpital. Le professionnel la lit avec un lecteur — c'est tout.",
      "**Elle ne contient pas** votre groupe sanguin ni votre dossier médical — juste vos informations administratives.",
      "**Carte perdue** : signalez-la immédiatement sur ameli.fr ou appelez le 36 46. Une nouvelle carte est gratuite.",
    ],
    question: "À quoi sert concrètement la carte Vitale chez le médecin ?",
    options: [
      { id: 'a', text: "Elle permet le remboursement automatique de vos soins par la Sécurité sociale", correct: true },
      { id: 'b', text: "Elle contient votre dossier médical complet", correct: false },
      { id: 'c', text: "Elle remplace l'ordonnance du médecin", correct: false },
    ],
    explication_reponse: "La carte Vitale déclenche le remboursement automatique — plus besoin d'envoyer des feuilles de soins papier. Elle ne contient aucune information médicale, seulement vos données administratives d'assuré.",
  },
  {
    id: 'cartevitale-2',
    numero: 2,
    titre: "Créer et utiliser votre espace Ameli",
    sousTitre: "Tout gérer en ligne",
    contexte: "L'espace Ameli sur ameli.fr vous permet de suivre vos remboursements, télécharger vos attestations et gérer votre situation — sans vous déplacer.",
    explication: [
      "**Ameli.fr** est le site officiel de l'Assurance Maladie. Votre espace personnel vous donne accès à tous vos remboursements et documents.",
      "**Pour créer votre compte** : allez sur ameli.fr → 'Créer mon compte' → entrez votre numéro de sécurité sociale et votre date de naissance.",
      "**Ce que vous pouvez faire** : consulter vos remboursements, télécharger votre attestation de droits, mettre à jour votre RIB, déclarer un médecin traitant.",
      "**L'attestation de droits** prouve que vous êtes bien couvert — elle vous sera demandée par votre mutuelle, votre employeur ou certaines administrations.",
      "**L'appli Ameli** sur smartphone est très pratique — carte Vitale dématérialisée, remboursements en temps réel, messagerie sécurisée avec votre CPAM.",
    ],
    question: "Vous avez besoin d'une attestation de droits pour votre mutuelle. Où la trouver rapidement ?",
    options: [
      { id: 'a', text: "Dans votre espace Ameli sur ameli.fr, section 'Mes démarches'", correct: true },
      { id: 'b', text: "En vous déplaçant à la CPAM avec une pièce d'identité", correct: false },
      { id: 'c', text: "En appelant le médecin traitant", correct: false },
    ],
    explication_reponse: "L'attestation de droits se télécharge en 30 secondes depuis votre espace Ameli — disponible 24h/24. Plus besoin de vous déplacer ni d'attendre. C'est l'un des documents les plus utiles à avoir sous la main.",
  },
  {
    id: 'cartevitale-3',
    numero: 3,
    titre: "Mettre à jour votre carte Vitale",
    sousTitre: "Quand et comment ?",
    contexte: "Votre carte Vitale doit être mise à jour régulièrement pour que vos droits soient correctement enregistrés. Beaucoup de gens l'ignorent.",
    explication: [
      "**Quand mettre à jour** : après un changement de situation (mariage, naissance, déménagement, changement de mutuelle, retraite), et au moins une fois par an.",
      "**Comment mettre à jour** : dans une borne automatique en pharmacie (borne verte), chez votre médecin, ou à la CPAM. Insérez votre carte, attendez quelques secondes.",
      "**Si vous ne mettez pas à jour**, certains remboursements peuvent être refusés ou votre mutuelle ne sera plus reconnue automatiquement.",
      "**Carte Vitale dématérialisée** : l'appli Ameli inclut désormais une carte Vitale numérique acceptée partout — pratique si vous avez oublié votre carte physique.",
      "**Numéro utile** : 36 46 (service Ameli, gratuit depuis un fixe) pour toute question sur vos droits ou votre carte.",
    ],
    question: "Où peut-on mettre à jour sa carte Vitale facilement ?",
    options: [
      { id: 'a', text: "Dans une borne automatique en pharmacie", correct: true },
      { id: 'b', text: "Uniquement à la CPAM sur rendez-vous", correct: false },
      { id: 'c', text: "La carte Vitale se met à jour automatiquement", correct: false },
    ],
    explication_reponse: "Les bornes vertes en pharmacie permettent de mettre à jour sa carte Vitale en moins d'une minute, sans rendez-vous, à n'importe quelle heure. C'est la solution la plus rapide et la plus accessible.",
  },
  {
    id: 'cartevitale-4',
    numero: 4,
    titre: "Comprendre vos remboursements",
    sousTitre: "Pourquoi ce n'est pas 100% ?",
    contexte: "Vous avez vu le médecin, payé 25€, et la Sécu ne vous rembourse que 16,50€. Pourquoi ? Et comment être mieux remboursé ?",
    explication: [
      "**La Sécurité sociale** rembourse une partie des soins — pas la totalité. Le reste à charge s'appelle le 'ticket modérateur'.",
      "**Taux de remboursement courant** : 70% du tarif de convention pour une consultation (soit 17,50€ sur 25€). Moins 1€ de participation forfaitaire = 16,50€ remboursés.",
      "**Le médecin traitant** est essentiel — si vous consultez un spécialiste sans passer par lui, le remboursement est réduit. Déclarez votre médecin traitant sur ameli.fr.",
      "**La mutuelle (complémentaire santé)** prend en charge tout ou partie du reste à charge. Sans mutuelle, vous payez le ticket modérateur de votre poche.",
      "**Complémentaire Santé Solidaire (CSS)** : si vos revenus sont modestes, vous pouvez avoir droit à une mutuelle gratuite ou très peu chère. Vérifiez sur complementaire-sante-solidaire.gouv.fr.",
    ],
    question: "Vous consultez un spécialiste sans passer par votre médecin traitant. Quelle conséquence ?",
    options: [
      { id: 'a', text: "Votre remboursement sera réduit par la Sécurité sociale", correct: true },
      { id: 'b', text: "Aucune conséquence, le remboursement est identique", correct: false },
      { id: 'c', text: "Vous ne serez pas remboursé du tout", correct: false },
    ],
    explication_reponse: "Sans passage par le médecin traitant, le taux de remboursement baisse — c'est le 'hors parcours de soins'. Déclarez votre médecin traitant sur ameli.fr pour bénéficier du meilleur remboursement possible.",
  },
];
